import React, {Fragment} from 'react';
import {useSelector, useDispatch} from 'react-redux'
import CommentStatusButtonItem from "../CommentStatusChangeButton";
import {receiveItems, updateItem} from "../../../actions/comment/comment";
import {showCommentBlockPopup, showCommentReplyPopup} from "../../../actions/popup";
import classnames from "classnames";
import {jsonResponseHandler} from "../../../utils/FetchHelper";
import * as querystring from "querystring";
import {addPrefix} from "../../../utils/UriUtil";

export default function CommentListItemButton({item}) {
  const currentUserId = useSelector(state => state.user.userId)
  const useCommentRecognition = useSelector(state => parseInt(state.blog.blogSettings.useCommentRecognition) !== 0)
  const dispatch = useDispatch()

  function handleReceiveItems(items, totalCount) {
    dispatch(receiveItems(items, totalCount))
  }
  function handleShowCommentBlockPopup(id) {
    dispatch(showCommentBlockPopup(id))
  }
  function handleUpdateItem(item) {
    dispatch(updateItem(item))
  }
  function handleShowCommentReplyPopup(id) {
    dispatch(showCommentReplyPopup(id))
  }

  function updateItemStatus(item, changes) {
    fetch(addPrefix("/manage/comment/" + item.id + "/approval.json"), {
      method: "put",
      credentials: "include",
      headers: {'Content-Type': 'application/x-www-form-urlencoded'},
      body: querystring.stringify(
        Object.assign({}, changes)
      )
    })
      .then(jsonResponseHandler(dispatch))
      .then(data => {
        item.processing = false;
        handleUpdateItem(item);
      })
      .catch(e => {
        item.processing = false;
        console.log(e)
      })
  }

  function handleMoveToTrash(e, item) {
    e.preventDefault();
    if (!item.editable) {
      alert('편집자 이상의 권한이 필요합니다.');
    } else {
      item.deleting = true;
      handleUpdateItem(item);
      fetch(addPrefix("/manage/comment/" + item.id + ".json"), {
        method: "delete",
        credentials: "include",
        headers: {'Content-Type': 'application/x-www-form-urlencoded'}
      })
        .then(data => {
          reFetchItems();
        })
        .catch(e => {
          item.deleting = false;
          handleUpdateItem(item);
          console.log(e)
        })
    }
  }

  function handleReject(item) {
    item.visibility = 0;
    item.isApproved = false;
    item.processing = true;
    updateItemStatus(item, {visibility: 0});
  }

  function handleApprove(item) {
    item.visibility = 2;
    item.isApproved = true;
    item.processing = true;
    updateItemStatus(item, {visibility: 2});
  }

  function reFetchItems() {
    fetch(addPrefix("/manage/comments.json" + location.search), {
      method: 'GET',
      credentials: 'include'
    })
      .then(r => r.json())
      .then(data => {
        handleReceiveItems(data.items, data.totalCount)
      })
      .catch(e => {
        console.log(e)
      })
  }

  function handleBlock(e, item) {
    e.preventDefault();
    if (item.authorId === currentUserId) {
      alert('본인이 작성한 글은 차단할 수 없습니다.');
    } else {
      handleShowCommentBlockPopup(item.id);
    }
  }

  function handleReply(e, item) {
    e.preventDefault();
    if (item.parent !== null) {
      alert('답글에는 답글을 작성할 수 없습니다.');
      return false;
    }

    if (useCommentRecognition) {
      handleShowCommentReplyPopup(item.id);
    } else {
      (item.isApproved)
        ? handleShowCommentReplyPopup(item.id)
        : alert('승인되지 않은 댓글에는 답글을 작성할 수 없습니다.');
    }
  }

  const isMyComment = item.authorId === currentUserId;
  const canReply = item.parent === null && !(useCommentRecognition && !item.isApproved);

  return (
    <Fragment>
      {useCommentRecognition &&
        <CommentStatusButtonItem
          handleApprove={handleApprove}
          handleReject={handleReject}
          item={item}
        />
      }
      <a href="#" className={classnames(`btn_post`, {'disabled': !canReply})} onClick={(e) => handleReply(e, item)}>답글</a>
      <a href="#" className={classnames(`btn_post`, {'disabled': isMyComment})} onClick={(e) => handleBlock(e, item)}>차단</a>
      <a href="#" className="btn_post" onClick={(e) => handleMoveToTrash(e, item)}>휴지통</a>
    </Fragment>
  )
}
